<template>
    <b-navbar-nav class="ml-lg-auto">
        <b-nav-item-dropdown right no-caret>
            <template v-slot:button-content>
                {{ $i18n.locale.toUpperCase() }}
            </template>
            <template v-for="language in $root.languages">
                <b-dropdown-item v-if="$i18n.locale !== language" @click="changeLanguage(language)">{{ language.toUpperCase() }}</b-dropdown-item>
            </template>
        </b-nav-item-dropdown>
    </b-navbar-nav>
</template>

<script>
    export default {
        name: 'language-switcher',
        methods: {
            changeLanguage(language) {
                return this.$root.setLang(language);
            }
        }
    }
</script>
